var _circle, _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullscreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 15,
    width: 26,
    height: 20,
    rx: 1.5,
    stroke: "#BBB6B6",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 19V18H15V19H16ZM21.2929 25.7071C21.6834 26.0976 22.3166 26.0976 22.7071 25.7071C23.0976 25.3166 23.0976 24.6834 22.7071 24.2929L21.2929 25.7071ZM17 25V19H15V25H17ZM16 20H22V18H16V20ZM15.2929 19.7071L21.2929 25.7071L22.7071 24.2929L16.7071 18.2929L15.2929 19.7071Z",
    fill: "#BBB6B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34 31V32H35V31H34ZM28.7071 24.2929C28.3166 23.9024 27.6834 23.9024 27.2929 24.2929C26.9024 24.6834 26.9024 25.3166 27.2929 25.7071L28.7071 24.2929ZM33 25V31H35V25H33ZM34 30H28V32H34V30ZM34.7071 30.2929L28.7071 24.2929L27.2929 25.7071L33.2929 31.7071L34.7071 30.2929Z",
    fill: "#BBB6B6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreen);
export default __webpack_public_path__ + "static/media/fullscreen.2c58bc49ac1ef2b185e1dc62fee79a64.svg";
export { ForwardRef as ReactComponent };